<script lang="ts" setup>
import type { Ref } from 'vue'
import { inject, ref } from 'vue'
import type { ICarousel } from './types'

const carouselProps: ICarousel | undefined = inject('carouselProps')

const totalSlides: Ref<number> = inject('totalSlides') || ref(0)
</script>

<template>
    <div
        class="flex shrink-0 grow-0 basis-full select-none items-center justify-center transition-opacity duration-200 lg:px-6"
        :class="!carouselProps?.hoverZoom && 'py-2'"
        role="tabpanel"
    >
        <div
            :class="[
                carouselProps?.hoverZoom && totalSlides > 1
                    ? 'lg:duration-400 lg:transition-transform lg:ease-in-out lg:group-hover/simple:scale-105'
                    : '',
                carouselProps?.hoverZoom ? 'lg:py-2' : 'px-4 lg:py-6',
            ]"
        >
            <slot />
        </div>
    </div>
</template>
